export const seoDataObj = {
  "": {
    description: "Roller World",
    title: "Roller World Film",
    image:
      "https://s3.us-west-1.amazonaws.com/assets.rollerworldfilm.com/social-general.png",
  },
};
